/**
 * @module app.prospection.search.searchDirective
 */
/**
 * @description Map directive
 * @constructor
 * @module app.prospection.search
 */
function bmMapDirective(localStorageService, departementsService, $timeout) {
    return {
        restrict: 'E',
        scope: true,
        templateUrl: 'prospection/search/partials/map.html',
        link: function(scope, element, attrs) {
            // Load departements list on refresh
            var departementsList = scope.searchCtrl.elementList;

            angular.forEach(element.find('path'), function(value, key) {
                var path = angular.element(value);
                var code = path.attr('data-code');

                if (departementsList.indexOf(code) > -1) {
                    path.toggleClass('selected');
                }
            });

            scope.$watchCollection('searchCtrl.elementList', function(newcol) {
                angular.forEach(element.find('path'), function(value, key) {
                    var path = angular.element(value);
                    var code = path.attr('data-code');

                    if (newcol.indexOf(code) > -1) {
                        path.addClass('selected');
                    }
                    else {
                        path.removeClass('selected');
                    }
                });
            });

            // On path click
            element.find('path').on('click', function(event) {
                var path = angular.element(event.currentTarget);
                var code = path.attr('data-code');
                // path.toggleClass('selected');
                $timeout(function() {
                    scope.searchCtrl.chooseDept(code);
                });
            });
        }
    };
}
bmMapDirective.$inject = ['localStorageService', 'departementsService', '$timeout'];

angular.module('app.prospection.search').directive('bmMap', bmMapDirective);
